import React from "react";
import { buildWhatsAppLink } from "../lib/api";
import { WhatsAppIcon } from "./BrandIcons";

const FloatingWhatsApp = () => (
  <a
    href={buildWhatsAppLink("Hi Style India Delhi — I came in via your website and would like to know more about your wholesale ladies ethnic wear.")}
    target="_blank"
    rel="noreferrer"
    data-testid="floating-whatsapp"
    aria-label="Chat with us on WhatsApp"
    className="fixed bottom-6 right-6 z-40 flex items-center gap-2 bg-[#25D366] hover:bg-[#1FB855] text-white pl-4 pr-5 py-3 shadow-lg transition-colors group"
  >
    <span className="relative flex w-2.5 h-2.5">
      <span className="animate-ping absolute inline-flex w-full h-full rounded-full bg-white opacity-75" />
      <span className="relative inline-flex w-2.5 h-2.5 rounded-full bg-white" />
    </span>
    <WhatsAppIcon size={18} style={{ color: "#ffffff" }} />
    <span className="text-[11px] tracking-[0.22em] uppercase font-semibold hidden sm:inline">Chat on WhatsApp</span>
    <span className="text-[11px] tracking-[0.22em] uppercase font-semibold sm:hidden">WhatsApp</span>
  </a>
);

export default FloatingWhatsApp;
